import React, { lazy } from "react";
import { Switch, Route } from "react-router-dom";
// import { useLocation } from "react-router";
import { LoginCallback, SecureRoute } from "@okta/okta-react";

import Home from "pages/Home";

const LoadSchedule = lazy(() =>
  import("pages/Admin/DataManagement/LoadSchedule")
);
const UsageInsights = lazy(() => import("pages/Admin/Users/UsageInsights"));
const Governance = lazy(() => import("pages/Admin/DataManagement/Governance"));
const PreTransactionList = lazy(() => import("pages/PreTransaction/List"));
const PreTransactionCreate = lazy(() => import("pages/PreTransaction/Create"));
const ManualUpload = lazy(() =>
  import("pages/Admin/ManualUpload/ManualUpload")
);
const TransactionUpload = lazy(() =>
  import("pages/Admin/TransactionUpload/TransactionUpload")
);

const TransactionList = lazy(() => import("pages/Transaction/List"));
const TransactionCreate = lazy(() => import("pages/Transaction/Create"));
const TransactionDetails = lazy(() => import("pages/Transaction/Details"));

const LeaseList = lazy(() => import("pages/Lease/List"));
const LeaseCreate = lazy(() => import("pages/Lease/Create"));
const LeaseDetails = lazy(() => import("pages/Lease/Details"));

const LeaseEventList = lazy(() => import("pages/LeaseEvent/List"));

const PropertyList = lazy(() => import("pages/Property/List"));
const PropertyCreate = lazy(() => import("pages/Property/Create"));
const PropertyDetails = lazy(() => import("pages/Property/Details"));
const UserDefinedFields = lazy(() =>
  import("pages/Admin/Management/UserDefinedFields/UserDefinedFields")
);
const TaskManagement = lazy(() => import("pages/Admin/Management/Task"));
const ClientList = lazy(() => import("pages/Admin/Clients/List"));
const ClientEdit = lazy(() => import("pages/Admin/Clients/Edit"));
const UserList = lazy(() => import("pages/Admin/Users/List"));
const UserEdit = lazy(() => import("pages/Admin/Users/Edit"));
const TemplateManagement = lazy(() =>
  import("pages/Admin/Management/Template")
);
const TransactionTypesCustom = lazy(() =>
  import("pages/Admin/Management/TransactionTypesCustom")
);
const CacheManagement = lazy(() =>
  import("pages/Admin/Management/Cache")
);

const Logout = lazy(() => import("pages/logout"));

const Resources = lazy(() => import("pages/Resources"));

const Unauthorized = lazy(() => import("pages/Unauthorized"));
const Error = lazy(() => import("pages/Error"));
const ComingSoon = lazy(() => import("pages/ComingSoon"));
const userSetting = lazy(() => import("pages/Admin/UserSettings"));
const accountAdminSettings = lazy(() => import("pages/Admin/AccountAdmin"));
const NotFound = lazy(() => import("components/NotFound"));
const CALLBACK_PATH = process.env.REACT_APP_CALLBACK_PATH;

const AppRoutes = () => {
  // const isLowerEnvironment = window.jllConfig.env !== "Production";
  // const isDevEnvironment = window.jllConfig.env === "Development";
  // const location = useLocation();
  // process.env.NODE_ENV !== "production";

  // useEffect(() => {
  //   if (isDevEnvironment && ReactGA) {
  //     ReactGA.initialize(GA_TRACKING_ID);
  //     ReactGA.send({
  //       hitType: "pageview",
  //       page: location.pathname + location.search,
  //     });
  //   }
  // }, [location]);

  return (
    <Switch>
      <Route exact path={CALLBACK_PATH} component={LoginCallback} />
      <SecureRoute exact path="/" component={Home} />
      <SecureRoute
        exact
        path="/pre-transaction"
        component={PreTransactionList}
      />
      <SecureRoute
        exact
        path="/pre-transaction/create"
        component={PreTransactionCreate}
      />
      <SecureRoute
        exact
        path="/pre-transaction/:tab/:id"
        component={TransactionDetails}
      />
      <SecureRoute exact path="/transaction" component={TransactionList} />
      <SecureRoute exact path="/transaction/create" component={TransactionCreate} />
      <SecureRoute
        exact
        path="/transaction/:tab/:id"
        component={TransactionDetails}
      />
      <SecureRoute exact path="/lease" component={LeaseList} />
      <SecureRoute exact path="/lease/create" component={LeaseCreate} />
      <SecureRoute exact path="/lease/details/:id" component={LeaseDetails} />
      <SecureRoute exact path="/lease-event" component={LeaseEventList} />
      <SecureRoute exact path="/property" component={PropertyList} />
      <SecureRoute exact path="/property/create" component={PropertyCreate} />
      <SecureRoute exact path="/property/details/:id" component={PropertyDetails} />
      <SecureRoute
        exact
        path="/admin/account-admin"
        component={accountAdminSettings}
      />
      <SecureRoute
        path="/admin/management/template"
        component={TemplateManagement}
      />
      <SecureRoute
        exact
        path="/admin/management/task"
        component={TaskManagement}
      />
      <SecureRoute
        exact
        path="/admin/management/transaction"
        component={TransactionList}
      />
      <SecureRoute
        exact
        path="/admin/management/transaction-types"
        component={TransactionTypesCustom}
      />
      <SecureRoute
        exact
        path="/admin/management/pre-transaction"
        component={PreTransactionList}
      />
      <SecureRoute
        exact
        path="/admin/data-management/load-schedule"
        component={LoadSchedule}
      />
      <SecureRoute
        exact
        path="/admin/data-management/governance"
        component={Governance}
      />
      <SecureRoute exact path="/admin/insights/user" component={ComingSoon} />
      <SecureRoute
        exact
        path="/admin/insights/developer"
        component={ComingSoon}
      />
      <SecureRoute
        exact
        path="/admin/dashboard/transaction-review"
        component={ComingSoon}
      />
      <SecureRoute
        exact
        path="/admin/dashboard/flex-review"
        component={ComingSoon}
      />
      <Route exact path="/logout" component={Logout}></Route>
      <SecureRoute exact path="/admin/clients" component={ClientList} />
      <SecureRoute
        exact
        path="/admin/clients/edit/:id"
        component={ClientEdit}
      />
      <SecureRoute exact path="/admin/manual-upload" component={ManualUpload} />
      <SecureRoute
        exact
        path="/admin/transaction-upload"
        component={TransactionUpload}
      />
      <SecureRoute
        exact
        path="/admin/management/user-defined-fields"
        component={UserDefinedFields}
      />
      <SecureRoute
        exact
        path="/admin/users/usage-insights"
        component={UsageInsights}
      />
      <SecureRoute
        exact
        path="/admin/data-management/cache"
        component={CacheManagement}
      />
      <SecureRoute exact path="/resources" component={Resources} />
      <SecureRoute exact path="/admin/users/user-list" component={UserList} />
      <SecureRoute exact path="/admin/clients/create" component={ClientEdit} />
      <SecureRoute exact path="/admin/users/edit/:id" component={UserEdit} />
      <SecureRoute exact path="/admin/users/create" component={UserEdit} />     
      <SecureRoute exact path="/users/user-setting" component={userSetting} />
      <Route exact path="/unauthorized" component={Unauthorized} />
      <Route exact path="/error" component={Error} />
      <Route component={NotFound} />
    </Switch>
  );
};

export default AppRoutes;
